import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { IconSearch } from '@commoncomponents/frontend-components/dist/components/Icons/Icons';
import { colors, breakpoints, } from '@commoncomponents/frontend-components/dist/styled';
const SearchBarWrapper = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background: white;
  border: 1px solid #b2bdc8;
  border-radius: 99px;
  margin-top: 10px;
  margin-bottom: 10px;

  @media ${breakpoints.md} {
    flex-direction: row-reverse;
  }
`;
const SearchBarIcon = styled.div `
  align-items: center;
  display: flex;
  padding-left: 16px;
  svg {
    height: 16px;
    width: 16px;
  }
  @media ${breakpoints.md} {
    padding: 0 24px 0 0;
    svg {
      height: 24px;
      width: 24px;
    }
  }
`;
const SearchBarInput = styled.input `
  background: transparent;
  width: 90%;
  height: 40px;
  padding: 10px 16px;
  -webkit-appearance: none;

  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: hidden;

  &:focus {
    outline: none !important;
  }

  &::placeholder {
    font-size: 14px;
    font-weight: 400;
    color: #697d8e;
  }

  @media ${breakpoints.md} {
    padding-left: 24px;
  }
`;
const SearchBar = ({ placeholder, onChange, intl: { formatMessage }, }) => {
    return (React.createElement(SearchBarWrapper, null,
        React.createElement(SearchBarIcon, null,
            React.createElement(IconSearch, { color: colors.rockyGrey })),
        React.createElement(SearchBarInput, { placeholder: placeholder && formatMessage(placeholder), onChange: onChange })));
};
export default injectIntl(SearchBar);
